import React from 'react';
import { GrClose } from 'react-icons/gr';
import { withRouter } from 'react-router';

import styles from './index.module.less';

import { Button, IntlMessage } from '$HVUI';
import { InactiveTimeoutModal } from '$Molecules/InactiveTimeoutModal/InactiveTimeoutModal';
import Modal from '$Molecules/Modal';

const appearTime = 60;

export class Modals extends React.Component {
    state = {
        modalIsOpen: false
    };

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    };

    handleLogout = () => {
        const { history, logoutPath } = this.props;
        // Add additional local storage clearing as needed
        return history.push(logoutPath);
    };
    render() {
        const { isKiosk, showLink } = this.props;
        const timeLimit = isKiosk ? 90 : 180;
        return (
            <div
                id="registration-modals"
                data-testid="registration-modals"
                className={styles['cancel-link-container']}
            >
                {showLink && (
                    <button
                        id="cancel-link"
                        className={styles['cancel-link']}
                        data-testid="cancel-link"
                        onClick={e => {
                            e.preventDefault();
                            this.setState({ modalIsOpen: true });
                        }}
                    >
                        <GrClose size=".75em" className="Icon--close" />
                        <IntlMessage id="all.cancel" defaultMessage="Cancel" />
                    </button>
                )}
                {showLink && (
                    <div
                        className={styles['modal-container']}
                        data-testid="cancel-modal-container"
                    >
                        <Modal
                            id="cancel-modal"
                            headerText={
                                <IntlMessage
                                    id="all.cancel-check-in"
                                    defaultMessage="Cancel check-in"
                                />
                            }
                            close={this.closeModal}
                            show={this.state.modalIsOpen}
                            columnWidth={8}
                            maxHeight="75vh"
                        >
                            <p
                                style={{
                                    marginTop: '1.25em',
                                    marginBottom: '1.5em'
                                }}
                            >
                                <IntlMessage
                                    id="all.are-you-sure-you-want-to-cancel"
                                    defaultMessage="Are you sure you want to cancel your check-in?"
                                />
                            </p>
                            {/* Some additional copy about losing progess, depending on whether you have authenticated or not? */}
                            <div className={styles['modal-links']}>
                                <Button
                                    id="confirm-no-cancel"
                                    onClick={this.closeModal}
                                    level="primary"
                                    text={
                                        <IntlMessage
                                            id="all.no-dont-cancel"
                                            defaultMessage="No, don't cancel"
                                        />
                                    }
                                />
                                <Button
                                    id="confirm-yes-cancel"
                                    onClick={() => {
                                        this.closeModal();
                                        this.handleLogout();
                                    }}
                                    level="secondary"
                                    style={{ fontSize: '.875rem' }}
                                    text={
                                        <IntlMessage
                                            id="all.yes-i-want-to-cancel"
                                            defaultMessage="Yes, I want to cancel"
                                        />
                                    }
                                />
                            </div>
                        </Modal>
                        <InactiveTimeoutModal
                            timeLimit={timeLimit}
                            modalAppearTime={appearTime}
                            handleLogout={this.handleLogout}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Modals);
